export const getPOSStatusLabel = (
  status: string | undefined,
  t: (key: string) => string,
) => {
  if (!status) {
    return t('backoffice.posStatus.unknownStatus');
  }

  return (
    POS_STATUS_TRANSLATION_KEYS[status] &&
    t(POS_STATUS_TRANSLATION_KEYS[status])
  ) || t('backoffice.posStatus.unknownError');
};

export const getPOSStatusTooltip = (
  status: string | undefined,
  t: (key: string) => string,
): string => (
  (status && POS_STATUS_TOOLTIP_KEYS[status] && t(POS_STATUS_TOOLTIP_KEYS[status])) || ''
);

const POS_STATUS_TRANSLATION_KEYS: Record<string, string> = {
  LINK_SUCCESSFULLY: 'backoffice.posStatus.LINK_SUCCESSFULLY',
  UNLINK_SUCCESSFULLY: 'backoffice.posStatus.UNLINK_SUCCESSFULLY',
  ASSOCIATE_SUCCESSFULLY: 'backoffice.posStatus.ASSOCIATE_SUCCESSFULLY',
  DISASSOCIATE_SUCCESSFULLY: 'backoffice.posStatus.DISASSOCIATE_SUCCESSFULLY',
  TERMINAL_WITH_ASSOCIATION_ACTIVE:
    'backoffice.posStatus.TERMINAL_WITH_ASSOCIATION_ACTIVE',
  ERROR_ASSOCIATE_ON_PROVIDER:
    'backoffice.posStatus.ERROR_ASSOCIATE_ON_PROVIDER',
  ERROR_DISASSOCIATE_ON_PROVIDER:
    'backoffice.posStatus.ERROR_DISASSOCIATE_ON_PROVIDER',
  TERMINAL_NOT_LINKED: 'backoffice.posStatus.TERMINAL_NOT_LINKED',
  TERMINAL_NOT_ASSOCIATED: 'backoffice.posStatus.TERMINAL_NOT_ASSOCIATED',
  TERMINAL_ALREADY_LINKED: 'backoffice.posStatus.TERMINAL_ALREADY_LINKED',
  TERMINAL_NOT_FOUND_IN_DB: 'backoffice.posStatus.TERMINAL_NOT_FOUND_IN_DB',
  TERMINAL_ALREADY_UNLINKED: 'backoffice.posStatus.TERMINAL_ALREADY_UNLINKED',
  TERMINAL_ALREADY_ASSOCIATED:
    'backoffice.posStatus.TERMINAL_ALREADY_ASSOCIATED',
  TERMINAL_ALREADY_UNASSOCIATED:
    'backoffice.posStatus.TERMINAL_ALREADY_UNASSOCIATED',
  TERMINAL_LINKED_TO_ANOTHER_COMPANY:
    'backoffice.posStatus.TERMINAL_LINKED_TO_ANOTHER_COMPANY',
  TERMINAL_ASSOCIATED_TO_ANOTHER_SELLER:
    'backoffice.posStatus.TERMINAL_ASSOCIATED_TO_ANOTHER_SELLER',
  TERMINAL_ALREADY_EXISTS_ON_DB:
    'backoffice.posStatus.TERMINAL_ALREADY_EXISTS_ON_DB',
  POS_CREATED_SUCCESSFULLY:
    'backoffice.posStatus.POS_CREATED_SUCCESSFULLY',
  ERROR_ON_CREATE: 'backoffice.posStatus.ERROR_ON_CREATE',
  TERMINAL_CREATED_AND_TEST_SUCCESS:
    'backoffice.posStatus.TERMINAL_CREATED_AND_TEST_SUCCESS',
  TERMINAL_ALREADY_REGISTERED:
    'backoffice.posStatus.TERMINAL_ALREADY_REGISTERED',
  ERROR_REGISTER_ON_PHOEBUS:
    'backoffice.posStatus.ERROR_REGISTER_ON_PHOEBUS',
  ERROR_ASSOCIATE_TEST_SELLER:
    'backoffice.posStatus.ERROR_ASSOCIATE_TEST_SELLER',
  TERMINAL_STATUS_NOT_ALLOWED:
    'backoffice.posStatus.TERMINAL_STATUS_NOT_ALLOWED',
};

const POS_STATUS_TOOLTIP_KEYS: Record<string, string> = {
  TERMINAL_CREATED_AND_TEST_SUCCESS:
    'backoffice.posStatusTooltip.TERMINAL_CREATED_AND_TEST_SUCCESS',
  TERMINAL_ALREADY_REGISTERED:
    'backoffice.posStatusTooltip.TERMINAL_ALREADY_REGISTERED',
  ERROR_REGISTER_ON_PHOEBUS:
    'backoffice.posStatusTooltip.ERROR_REGISTER_ON_PHOEBUS',
  ERROR_ASSOCIATE_TEST_SELLER:
    'backoffice.posStatusTooltip.ERROR_ASSOCIATE_TEST_SELLER',
  LINK_SUCCESSFULLY:
    'backoffice.posStatusTooltip.LINK_SUCCESSFULLY',
  UNLINK_SUCCESSFULLY:
    'backoffice.posStatusTooltip.UNLINK_SUCCESSFULLY',
  ASSOCIATE_SUCCESSFULLY:
    'backoffice.posStatusTooltip.ASSOCIATE_SUCCESSFULLY',
  DISASSOCIATE_SUCCESSFULLY:
    'backoffice.posStatusTooltip.DISASSOCIATE_SUCCESSFULLY',
  TERMINAL_ALREADY_ASSOCIATED:
    'backoffice.posStatusTooltip.TERMINAL_ALREADY_ASSOCIATED',
  TERMINAL_ALREADY_LINKED:
    'backoffice.posStatusTooltip.TERMINAL_ALREADY_LINKED',
  TERMINAL_ALREADY_UNLINKED:
    'backoffice.posStatusTooltip.TERMINAL_ALREADY_UNLINKED',
  TERMINAL_ALREADY_UNASSOCIATED:
    'backoffice.posStatusTooltip.TERMINAL_ALREADY_UNASSOCIATED',
  TERMINAL_WITH_ASSOCIATION_ACTIVE:
    'backoffice.posStatusTooltip.TERMINAL_WITH_ASSOCIATION_ACTIVE',
  TERMINAL_NOT_LINKED:
    'backoffice.posStatusTooltip.TERMINAL_NOT_LINKED',
  TERMINAL_NOT_ASSOCIATED:
    'backoffice.posStatusTooltip.TERMINAL_NOT_ASSOCIATED',
  TERMINAL_NOT_FOUND_IN_DB:
    'backoffice.posStatusTooltip.TERMINAL_NOT_FOUND_IN_DB',
  TERMINAL_LINKED_TO_ANOTHER_COMPANY:
    'backoffice.posStatusTooltip.TERMINAL_LINKED_TO_ANOTHER_COMPANY',
  TERMINAL_ASSOCIATED_TO_ANOTHER_SELLER:
    'backoffice.posStatusTooltip.TERMINAL_ASSOCIATED_TO_ANOTHER_SELLER',
  ERROR_ASSOCIATE_ON_PROVIDER:
    'backoffice.posStatusTooltip.ERROR_ASSOCIATE_ON_PROVIDER',
  ERROR_DISASSOCIATE_ON_PROVIDER:
    'backoffice.posStatusTooltip.ERROR_DISASSOCIATE_ON_PROVIDER',
  TERMINAL_STATUS_NOT_ALLOWED:
    'backoffice.posStatusTooltip.TERMINAL_STATUS_NOT_ALLOWED',
};
